import type { FC } from 'react';

import { AppViewer } from '../components/AppViewer/AppViewer';
import { useStyleFromUrl, useViewerControlsFromUrl } from './StyleViewerPage.hooks';

export const StyleViewerPage: FC = () => {
  useStyleFromUrl();
  const { controlsLayout, controlsStyle } = useViewerControlsFromUrl();

  return <AppViewer controlsLayout={controlsLayout} controlsStyle={controlsStyle} />;
};

